import React, { useState } from 'react'
import SingleColor from './SingleColor'
import Values from 'values.js'

function App() {

  const [color, setColor] = useState('');
  const [error, setError] = useState(false);
  const [list, setList] = useState(new Values('#f15025').all(10));

  const handleSubmit = (e) => {
    e.preventDefault();
    try {
      let colors = new Values(color).all(10)
      setList(colors)
      console.log(colors)
    } catch (error) {
      setError(true);
      console.log(error)
    }
    console.log('hello Yogesh Sir');
  }

  // Function to handle color selection from color input
  const handleColorSelection = (e) => {
    setColor(e.target.value); // Set the color value to the selected color
  }

  return (
    <>
      <section className='container'>
        <h3>color generator project</h3>
        <form onSubmit={handleSubmit}>
          <input type="color" onChange={handleColorSelection} /> {/* Add onChange event handler */}
          <input type='text' value={color} onChange={(e) => setColor(e.target.value)} placeholder='#f15025' className={`${error ? 'error' : null}`}></input>
          <button className='btn' type='submit'>Submit</button>
        </form>
      </section>
      <section className='colors'>{list.map((color, index) => {
        const hex = color.hex;
        return <SingleColor key={index}{...color} index={index} hexColor={color.hex}></SingleColor>
      })}</section>
    </>
  )
}

export default App
